<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('notificationFilter.new_metadata')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('notificationFilter.new_metadata')}}</h2>
          <base-tooltip-icon v-if="tooltipText" size="sm" :content="tooltipText" class="ml-2"/>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 40vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="value">
              
              <accessible-el-select
                prop="value"
                v-model="form.value"
                :isMultiple="multiple"
                :options="values.map(x => ({ id: x, value: x, name: x }))"
                id-prefix="inputselectallmetadatabyclient"
                :isDisabled="isLoadingSelect"
              >
                <template #label>
                  <base-obligatory-icon/>{{$t('notificationFilter.metadata_campo')}}
                </template>
              </accessible-el-select>

            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button mode="secondary-phantom-blue"
          class="w-full"
          v-if="multiple && !isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="handleSelectAll" 
          :loading="isLoadingSelect"
          />
        <base-button v-else-if="multiple" :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
          class="w-full"
          @click="handleUnSelectAll"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
        <div v-if="multiple" class="w-48"></div>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
          class="w-full"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'input-select-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: null,
    },
    values: {
      type: Array,
      default: () => [],
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        value: null
      },
      // values: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    // const data = await getRulesSimple({ idGrupo: this.$route.params.id })
    // if (data.blnError === true) {
    //   this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
    // } else {
    //   data.Respuesta.forEach(row => {
    //     this.rules.push({ id: row.idRegla, value: row.Nombre })
    //   })
    // }
    this.isLoadedData = true
  },
  computed: {
    isEmptyList: function () {
      return this.values === undefined || this.values === null || this.values.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (!this.multiple) return false
      if (!this.isEmptyList && this.form.value && this.values.length === this.form.value.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      if (this.multiple) this.form.value = []
      else this.form.value = null
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.value)
      // if (this.multiple) this.form.value = []
      // else this.form.value = null
    },
    handleSelectAll: async function () {
      // this.form.location = []
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.values.forEach(element => {
        setTimeout(() => {
          this.form.value.push(element.id)
          if (this.form.value.length === this.values.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.value.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.value.pop()
          if (this.form.value.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    }
  }
}
</script>

